<template>
  <div class="charger-page">
    <div class="page-title">Charger Details</div>

    <!-- 门店卡片 -->
    <div class="store-card">
      <img class="store-img" src="@/assets/imgs/banner-home.jpg" />
      <div class="store-info">
        <div class="store-name">{{ cabinet.shopname }}</div>
        <div class="store-address">{{ cabinet.shopAddress || "---" }}</div>
      </div>
    </div>

    <!-- 价格模块 -->
    <div class="pricing-wrapper">
      <div class="pricing-box">
        <div class="pricing-title">{{ i18n.rentalPricing }}</div>
        <div class="price-item">
          · {{ `${i18n.firstMinutesFree}`.format(cabinet) }}
        </div>
        <div class="price-item">
          · {{ `${i18n.pricePerDuration}`.format(cabinet) }}
        </div>

        <div class="price-item">
          · {{ `${i18n.maximumDailyCharge}`.format(cabinet) }}
        </div>
      </div>

      <div class="policy">
        <div class="policy-title">
          {{ i18n.depositPolicyTitle }}
        </div>

        <div class="deposit-price">
          {{
            `${i18n.depositTemporary}`.format({
              ...cabinet,
              ...cabinet.priceStrategy
            })
          }}
        </div>

        <div class="policy-desc">
          {{ i18n.depositDesc1 }}<br />
          {{ i18n.depositDesc2 }}<br />
          <span class="policy-desc-p">
            {{
              `${i18n.depositDesc3}`.format({
                ...cabinet,
                ...cabinet.priceStrategy
              })
            }}
          </span>
        </div>
      </div>
    </div>

    <!-- 说明 -->
    <div class="bottom-desc">
      {{ i18n.returnAnyStation }}<br />
      {{ i18n.universalCableIncluded }}
    </div>

    <!-- 线缆 -->
    <div class="cables">
      <div class="cable" v-for="list in point_list" :key="list.name">
        <img class="icon" :src="list.icon" />
        <div>{{ list.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    cabinet: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState(["browser", "system"]),
    i18n() {
      return this.$t("home");
    },
    i18nMsg() {
      return this.$t("msg");
    },
    priceStrategy() {
      return this.cabinet && this.cabinet.priceStrategy;
    },
    priceUnitMap() {
      return {
        0: "minutes",
        1: "hours",
        2: "days"
      };
    }
  },
  data() {
    return {
      rent_type: 1, // 1: standard, 2: fast charge
      point_list: [
        {
          show: true,
          name: "iOS",
          icon: require("@/assets/imgs/shop/icon_lightning.png")
        },
        {
          show: true,
          name: "Micro",
          icon: require("@/assets/imgs/shop/icon_micro_usb.png")
        },
        {
          show: true,
          name: "Type-C",
          icon: require("@/assets/imgs/shop/icon_typec.png")
        }
      ]
    };
  },
  methods: {
    setRentType(type) {
      this.rent_type = type;
      this.$set(this.point_list[2], "show", type !== 2);
      this.$emit("onRentType", type);
    },
    supportType(type) {
      return (
        this.cabinet &&
        this.cabinet.supportRentalProductType &&
        this.cabinet.supportRentalProductType.includes(type)
      );
    }
  },
  mounted() {
    const _cabinet = this.cabinet || {};
    if (_cabinet && _cabinet.priceStrategy) {
      console.log(" ~ _cabinet:", _cabinet, _cabinet.priceStrategy);
      if (_cabinet.advancedFlag) {
        this.rent_type = _cabinet.priceStrategy.rentalProductType;
        this.$set(this.point_list[2], "show", this.rent_type !== 2);
      } else {
        this.rent_type = 1;
      }
      const _priceUnit = this.priceUnitMap[this.priceStrategy.priceUnit];
      this.$set(this.cabinet, "priceUnit", _priceUnit);
    }
  }
};
</script>

<style lang="less" scoped>
.charger-page {
  height: 100vh;
  min-height: 100vh;
  padding: 0 0.48rem;
  overflow-y: auto;
  background-color: #fff;
}

.page-title {
  font-size: 0.58rem;
  font-weight: 700;
  padding: 0.24rem 0;
}

/* ========== 门店卡片 ========== */

.store-card {
  background: #fff;
  border-radius: 0.32rem;
  overflow: hidden;
  box-shadow: 0 0.16rem 0.4rem rgba(0, 0, 0, 0.12);

  .store-img {
    width: 100%;
    height: 2.8rem;
    object-fit: cover;
  }

  .store-info {
    padding: 0.24rem 0.48rem 0.36rem;

    .store-name {
      font-size: 0.48rem;
      font-weight: 600;
      margin-bottom: 0.08rem;
    }

    .store-address {
      font-size: 0.32rem;
      color: #888;
    }
  }
}

/* ========== 价格区域 ========== */

.pricing-wrapper {
  margin-top: 0.56rem;
  border: 4px dashed #f4a000;
  border-radius: 0.32rem;
  padding: 0.28rem;
  background: #fff;
}

.pricing-box {
  background: #f7efe3;
  border-radius: 0.3rem;
  padding: 0.24rem;

  .pricing-title {
    text-align: center;
    font-size: 0.46rem;
    font-weight: bold;
  }

  .price-item {
    font-size: 0.36rem;
    color: #f4a000;
    text-indent: 2.2em;
  }
}

.policy {
  margin-top: 0.24rem;

  .policy-title {
    font-size: 0.36rem;
    font-weight: 600;
    margin-bottom: 0.08rem;
  }

  .deposit-price {
    font-size: 0.38rem;
    font-weight: 600;
    margin-bottom: 0.08rem;
  }

  .policy-desc {
    font-size: 0.32rem;
    color: #999;
    &-p {
      color: #666;
      font-weight: 600;
    }
  }
}

/* ========== 底部说明 ========== */

.bottom-desc {
  margin: 0.32rem 0 0.16rem;
  text-align: center;
  font-size: 0.42rem;
  font-weight: bold;
}

/* ========== 线缆图标 ========== */

.cables {
  width: 72%;
  display: flex;
  justify-content: space-evenly;
  margin: 30px auto 20vh;

  .cable {
    text-align: center;
    font-size: 0.32rem;

    .icon {
      width: 0.76rem;
      height: 0.76rem;
      margin: 0 auto 0.06rem;
    }
  }
}
</style>
